<template>
  <Teleport to="body">
    <div
      class="fixed top-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none"
      role="region"
      aria-label="Notificaciones"
      aria-live="polite"
    >
      <TransitionGroup name="toast">
        <div
          v-for="t in toasts"
          :key="t.id"
          :role="t.type === 'error' ? 'alert' : 'status'"
          :aria-live="t.type === 'error' ? 'assertive' : 'polite'"
          class="pointer-events-auto max-w-sm rounded-xl shadow-lg px-4 py-3 flex items-start gap-3 border"
          :class="{
            'bg-green-50 border-green-200 text-green-800': t.type === 'success',
            'bg-red-50 border-red-200 text-red-800': t.type === 'error',
            'bg-blue-50 border-blue-200 text-blue-800': t.type === 'info',
          }"
        >
          <!-- Ícono por tipo -->
          <Check v-if="t.type === 'success'" :size="20" class="shrink-0 mt-0.5" />
          <AlertTriangle v-else-if="t.type === 'error'" :size="20" class="shrink-0 mt-0.5" />
          <Info v-else :size="20" class="shrink-0 mt-0.5" />

          <div class="flex-1 min-w-0">
            <p class="text-sm whitespace-pre-line">{{ t.message }}</p>
            <button
              v-if="t.action?.onClick"
              type="button"
              class="mt-1.5 inline-flex items-center gap-1 text-xs font-semibold underline underline-offset-2 hover:opacity-80 transition-opacity"
              @click="t.action.onClick?.(); remove(t.id)"
            >
              {{ t.action.label }}
              <ChevronRight :size="12" />
            </button>
            <a v-else-if="t.action?.href"
              :href="t.action.href"
              class="mt-1.5 inline-flex items-center gap-1 text-xs font-semibold underline underline-offset-2 hover:opacity-80 transition-opacity">
              {{ t.action.label }}
              <ChevronRight :size="12" />
            </a>
          </div>

          <button
            class="shrink-0 opacity-60 hover:opacity-100 transition-opacity"
            :aria-label="`Cerrar: ${t.message}`"
            @click="remove(t.id)"
          >
            <X :size="16" />
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { Check, AlertTriangle, Info, ChevronRight, X } from 'lucide-vue-next'
import { useToast } from '~/composables/useToast'

const { toasts, remove } = useToast()
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  transform: translateX(100%);
  opacity: 0;
}
.toast-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
</style>
